<template>
    <div class="container">
        <div class="cart order">
            <div v-if="loaderBig" style="text-align: center">
                <img src="/uikit/svg/icons/loader.svg" alt="" style="width: 60px; height: 60px;">
            </div>

            <template v-else>
                <template v-if="cart !== null  && isCartEmpty()">
                    <EmptyCart></EmptyCart>
                </template>

                <template v-if="!isCartEmpty()">
                    <h1 class="cart__title">{{ title }}</h1>

                    <div class="grid" :class="{'disable': loader.cart}">
                        <div class="grid__col grid__col--md-8">
                            <UserComponent
                                @createLoader="createLoader">
                            </UserComponent>

                            <DeliveryComponent
                                v-if="isEquipmentInCart"
                                @createLoader="createLoader"
                                @reloadCart="reloadCart">
                            </DeliveryComponent>

                            <PaymentComponent
                                v-if="isPaymentInCart"
                                @checkPayLatter="checkPayLatter"
                                @createLoader="createLoader">
                            </PaymentComponent>

                            <NoteComponent
                                @createCommentValue="createCommentValue">
                            </NoteComponent>
                        </div>

                        <div class="grid__col grid__col--md-4">
                            <CartTotalComponent
                                :cart="cart"
                                :loader="loader"
                                @nextButtonHandler="nextButtonHandler">
                            </CartTotalComponent>
                        </div>
                    </div>
                </template>
            </template>

        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import VModal from 'vue-js-modal';

import BxBaseApp from "../../BxBaseApp";
import BaseMethods from "../components/BaseMethods.vue";

import UserComponent from "../components/cart-confirm/UserComponent";
import DeliveryComponent from "../components/cart-confirm/DeliveryComponent";
import PaymentComponent from "../components/cart-confirm/PaymentComponent";
import NoteComponent from "../components/cart-confirm/NoteComponent";
import CartTotalComponent from "../components/cart-confirm/CartTotalComponent";
import EmptyCart from "../components/EmptyCart";

import api from '../../../plugins/api'
import message from '../../../plugins/message'
import utils from "../../../lib/utils";
import dadata from "../../../plugins/dadata.js";

Vue.use(VModal);
Vue.use(api);
Vue.use(message);
Vue.use(dadata);

const ERROR_REPORTER = window.ERROR_REPORTER
const MESSAGE_TYPE_ERROR = window.MESSAGE_TYPE_ERROR
const PAY_LATER = '1'; //Константа ID оплаты позднее

export default {
    name: 'CartConfirm',
    components: {
        CartTotalComponent,
        UserComponent,
        DeliveryComponent,
        PaymentComponent,
        NoteComponent,
        EmptyCart,
    },
    mixins: [BxBaseApp, BaseMethods],
    data() {
        return {
            cart: null,
            userLogin: null,
            loaderBig: true,
            loader: {
                cart: true,
            },
            isEquipmentInCart: false,
            isPaymentInCart: false,
            comment: '',
            isConfirmPage: true
        }
    },
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        title() {
            if (this.$route) {
                return this.$route.meta.title
            }
            return null
        }
    },
    methods: {
        checkPayLatter(payId) {
            this.cart['PAY_LATER'] = payId === PAY_LATER;
        },
        nextButtonHandler() {
            window.mgoTriggerEvent('order-confirm');
            this.checkBeforeOrder(this.doOrder);
        },
        doOrder() {
            const t = this;
            const sendData = {
                'backurl': location.href,
                'comment': t.comment
            };

            t.loader.cart = true

            t.$api.request('/api/order/createOrder/', 'post', sendData).then((response) => {

                window.mgoTriggerEvent('do-order', [response?.data]);

                if (response?.data['content'] && response?.data['content'] !== undefined) {
                    if (response?.data['link']) {
                        let form = document.createElement('form');
                        form.setAttribute('method', 'POST');
                        form.setAttribute('action', response?.data['link']);
                        form.innerHTML = response?.data['content'];
                        let sel = form.querySelectorAll('input[name="LMI_PAYMENT_NO"]');
                        if (sel.length > 0) {
                            sel[0].setAttribute('value', t.userLogin);
                        }

                        form.style = 'display:none';
                        document.body.appendChild(form);
                        form.submit();
                    } else {
                        ERROR_REPORTER.showMessage('Ошибка при попытке отправки на платёжный шлюз', MESSAGE_TYPE_ERROR);
                    }
                } else {
                    if (response?.data['link']) {
                        if (t.$router && !utils.isAbsoluteUrl(response?.data['link'])) {
                            t.$router.replace(response?.data['link'])
                        } else {
                            window.location.href = response?.data['link']
                        }
                    }
                }
            }).catch((error) => {
                let response = error.response.data;
                switch (response?.data['error_type']) {
                    case 'busy_numbers':
                    case 'stop_8_800_phis':
                    case 'external_error':
                        t.$api.request(
                            '/ajax_new/cookieFunctions.php',
                            'post',
                            {
                                action: 'set',
                                name: response?.data['error_type'] === 'external_error' ? 'ARR_EXTERNAL_ERROR' : 'ARR_BUSY_NUMBERS',
                                value: encodeURIComponent(response?.data['numbers']),
                                time: 3600
                            },
                        );
                        t.stopReloadCart();
                        ERROR_REPORTER.showMessage(response?.errors[0]['message'], MESSAGE_TYPE_ERROR);
                        break;
                    case 'test_offers':
                        t.reloadCart();
                        t.stopReloadCart();
                        ERROR_REPORTER.showMessage(response?.errors[0]['message'], MESSAGE_TYPE_ERROR);
                        break;
                    case 'no_pay_system':
                        t.stopReloadCart();
                        ERROR_REPORTER.showMessage('Выберите способ оплаты', MESSAGE_TYPE_ERROR);
                        break;
                    default:
                        t.stopReloadCart();
                        ERROR_REPORTER.showMessage(
                            response?.errors[0]['message'] ?? 'Ошибка при отправке заказа',
                            MESSAGE_TYPE_ERROR
                        );
                }
            });

        },
        reloadCart() {
            const sendData = {
                isReload: 'Y'
            }

            this.loader.cart = true;

            this.$api.request(this.apiUrl + 'getData/', 'post', sendData).then((response) => {
                this.cart = response.data.cart
                this.loader.cart = false;
            }).catch(() => {
                const message = 'Ошибка при обновлении корзины'
                ERROR_REPORTER.showMessage(message, MESSAGE_TYPE_ERROR)
                this.stopReloadCart();
            });
        },
        stopReloadCart() {
            Object.keys(this.loader).forEach(item => {
                this.loader[item] = false;
            })
        },
        createCommentValue(value) {
            this.comment = value;
        },
        createLoader(key, value) {
            this.loader.cart = value;
            this.loader[key] = value;
        }
    },
    mounted() {
        this.initData()
            .finally(() => {
                let intervalId = setInterval(() => {
                    Object.keys(this.loader).forEach(item => {
                        if (this.loader[item]) {
                            return false;
                        }
                    });

                    clearInterval(intervalId);
                    this.loaderBig = false;
                }, 1000);
            })
    }
}
</script>

<style lang="scss">
@import "../../../../../design_kit/site/blocks/order/style.scss";
@import "../../../../../design_kit/site/blocks/input/light-theme.scss";
@import "../../../../../design_kit/site/blocks/list/style.scss";
@import "../../../../../design_kit/site/base/svg-font.scss";
@import "../../../../../design_kit/site/blocks/icon/style.scss";
@import "../../../../../design_kit/site/blocks/sel/style.scss";
@import "../../../../../design_kit/site/blocks/payment/style.scss";
@import "../../../../../design_kit/site/blocks/delivery/style.scss";
@import "../../../../../design_kit/site/blocks/order/style.scss";
@import "../../../../../design_kit/libs/arcticmodal/jquery.arcticmodal-0.3.css";

.disable-div {
    pointer-events: none;
}
</style>
